module.exports = __webpack_public_path__ + "static/media/5f8de7ec5ae7590275f073fc_logo_200x200.8015e96f.png";